import React, { Component } from 'react'
import axios from "axios";
import { pricesFormat } from '../functions/pricesFormat.js';
import { DateFormatMAS90 } from '../functions/dateFormat.js';
import { MobileDisp, NumberFormat } from '../functions/generalFunctions';
import { InvoicePDF } from '../components/InvoicePDF';
import { DownloadInvoicePDF } from '../components/DownloadInvoicePDF';
import { getValueCookie } from '../services/cookieService';
import server from "../services/Connection/backEndLink";
import "../css/general-style.css"
import '../css/table-responsive.css'
import LoadingWindow from '../components/LoadingWindow';

// Menu
import { Menu } from "../components/Menu/Menu";


import { MdEdit } from "react-icons/md";
import SmallModal from '../components/SmallModal.js';
import Swal from 'sweetalert2';

export default class ShowCustomer extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        Customer: null,
        invoices: [],
        invoiceProducts: [],
        shippingAddresses: [],
        loadInvoice: null,
        invoiceSelected: null,
        shippingAddressesModal: false,
        addShippingAddressModal: false,
        upsertShippingAddressesModal: false,
        isCreatingShippingAddress: false,
        shippingAddressSelected: {id: '', customerNo: '', name: '', shipping_street: '', shipping_city: '', shipping_state: '', shipping_zip: ''},
    }

    componentDidMount(){
        const stored = localStorage.getItem('selectedCustomer');
        if (stored) {
            const Customer = JSON.parse(stored);
            this.setState({ Customer });
            // localStorage.removeItem('selectedCustomer');
            this.fetchInvoices(Customer.CustomerNo);
        }
    }

    formatDate(date){
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // enero = 0
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    
    async fetchInvoices(customerNo) {
        const today = new Date();
        let oneMonthAgo = new Date();
        oneMonthAgo.setDate(today.getDate() - 30);
        
        const company = getValueCookie('CompanyId');
        const startDate = this.formatDate(oneMonthAgo)
        const endDate = this.formatDate(today)
        let responseBack
        const url = server.url

        const payload = {
            data: {
                idCompany: Number(company),
                CustomerNo: customerNo,
                StartDate: startDate,
                EndDate: endDate
            }
        }

        const query = "/invoice/history/header/customer"
            await axios.post(`${url}${query}`, payload).then(
                response => {
                    responseBack = response.data.data.slice(0,10)
                }
            ).catch(error => {
                console.log(error)
                responseBack = []
            })
        this.setState({invoices: responseBack})
    }

    async fetchProducts(invoiceNo) {
        const payload = {
            data: {
                idCompany: 3,
                HeaderSeqNo: '000000',
                InvoiceNo: invoiceNo
            }
        }
        const query = "/invoice/history/detail";
        let responseBack = null;

        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                if (response.data.status.code === 1){
                    responseBack = response.data;
                }
            }
        ).catch(error => {
            console.log(error)
        })
        return responseBack.data;
    }

    realLongDetail() {
        let cont = 0
        this.state.invoiceProducts.forEach(element => {
            if (element.Visible === 1 && element.quantityShipped > 0) {
                cont++
            }
        });
        return cont
    }

    async loadInvoice(invoice) {
        const invoiceProducts = await this.fetchProducts(invoice.InvoiceNo)

        // Add totals
        const totals = invoiceProducts.reduce(
            (acc, item) => {
                // acc.totalCost += item.UnitCost;
                acc.totalWeight += (item.LineWeight * item.QuantityShipped);
                acc.totalQuantityShipped += item.QuantityShipped;
                return acc;
            },{totalWeight: 0, totalQuantityShipped: 0});

        // Product total price
        const invoiceProductsWTotals = invoiceProducts.map(item => ({
            ...item,
            totalCost: item.UnitPrice * item.QuantityShipped
        }));
        const invoiceWithTotals = {
            ...invoice,
            ...totals
        };
        
        const invoiceComplete = this.printDetail(invoiceProductsWTotals)
        this.setState({invoiceSelected: invoice.InvoiceNo, loadInvoice: invoiceWithTotals, invoiceProducts: invoiceComplete})
    }

    printDetail(invoice) {
        let detail = []
        const renameKeys = invoice.map(({ ItemCode, ItemCodeDesc, QuantityOrdered, QuantityShipped, ...rest }) => ({
            ...rest,
            abbreviatedDesc: ItemCodeDesc,
            itemCode: ItemCode,
            quantityOrdered: QuantityOrdered,
            quantityShipped: QuantityShipped
        }));

        renameKeys.forEach(element => {
            if (element.quantityShipped !== 0) {
                detail.push(element)
            }
        });
        const tamBreak = getValueCookie("CompanyId") === '3' ? 55 : 45
        const res = detail.length % tamBreak
        for (let a = 0; a < tamBreak - res; a++) {
            const itemJson = {
                itemCode: ' ',
                abbreviatedDesc: ' ',
                upc: ' ',
                quantity: ' ',
                ShipWeight: ' ',
                StandardUnitCost: ' ',
                LastTotalUnitCost: ' ',
                UnitPrice: ' ',
                upc2: ' ',
                caseupc: ' ',
                BIN: " ",
                totalWeight: ' ',
                Comment: " ",
                unitCost: ' ',
                quantityOrdered: ' ',
                quantityReceived: ' ',
                quantityShipped: ' ',
                totalCost: ' ',
                totalFreight: ' ',
                Visible: ' ',
                BatchUnits: ' ',
                DiscountUnits: ' ',
                SuggestedDiscount: ' '
            }
            detail.push(itemJson)
        }
        return detail
    }

    textTermsCode(num) {
        switch (Number(num)) {
            case 0:
                return 'Pay in Advance'
            case 1:
                return 'FOB Taiwan'
            case 7:
                return 'Net 07 Days'
            case 10:
                return 'Net 10 Days'
            case 15:
                return 'Net 15 Days'
            case 21:
                return 'Net 21 Days'
            case 30:
                return 'Net 30 Days'
            case 45:
                return 'Net 45 Days'
            default:
                return ''
        }
    }
    
    getAllShippingAddress = async() => {
        const customer = this.state.Customer
        let company = getValueCookie('CompanyId')
        let responseBack;
        const payload = {
            data: {
                companyId: Number(company),
                customerNo: customer.CustomerNo
            }
        }

        const query = "/sales/get-shipping-address-for-customer";
        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                responseBack = response.data.data.data
            }
        ).catch(error => {
            console.log(error)
            responseBack = []
        })
        
        // Get all shipping address 
        this.setState({shippingAddresses: responseBack})
    }

    addShippingAddresses = async () => {
        const customer_no = this.state.Customer.CustomerNo;
        const {
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;

         // Validation before update
        if (
            !shipping_name ||
            !shipping_street ||
            !shipping_city ||
            !shipping_state ||
            !shipping_zip
        ) {
            Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Please fill in all fields before updating.',
            confirmButtonText: 'OK',
            });
            return;
        }

        const url = server.url
        let responseBack;
        const payload = {
            data: {
                companyId: getValueCookie('CompanyId'),
                customerNo: customer_no,
                shipping_name,
                shipping_street,
                shipping_city,
                shipping_state,
                shipping_zip,
            }
        };
        let query = "/sales/create-shipping-address-for-customer";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data.data
            }
        ).catch(error => {
            console.log(error)
        })
        
        this.updateShippingAddressList(responseBack, payload.data);
        this.setState({isCreatingShippingAddress: false})
        // if (responseBack.status.code === 1) {
        //     // Actualizar cambios en el estado
        //     this.setState({shippingAddresses: [...this.state.shippingAddresses, responseBack]});
        //     // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
        //     this.clearFormInputs()
        //     this.handleModalClose("upsertShippingAddressesModal")
        // } else {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error',
        //         text: 'An error occurred while updating the shipping address. Please try again.',
        //         confirmButtonText: 'OK',
        //     });
        //     console.error("Error updating shipping address:", responseBack.status.message);
        // }
    }
    
    upsertShippingAddress = async () => {
        const {
            id,
            customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;

         // Validation before update
        if (
            !shipping_name ||
            !shipping_street ||
            !shipping_city ||
            !shipping_state ||
            !shipping_zip
        ) {
            Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Please fill in all fields before updating.',
            confirmButtonText: 'OK',
            });
            return;
        }

        const url = server.url
        let responseBack;
        const payload = {
            data: {
            id,
            companyId: getValueCookie('CompanyId'), 
            customerNo: customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip,
            }
        };
        let query = "/sales/update-shipping-address-for-customer";
        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data.data
            }
        ).catch(error => {
            console.log(error)
        })
        this.updateShippingAddressList(responseBack);
        // if (responseBack.status.code === 1) {
        //     // Actualizar cambios en el estado
        //     const shippingAddresses = this.state.shippingAddresses.map(item => {
        //         if (item.id === id) {
        //             return {
        //                 ...item,
        //                 customer_no,
        //                 shipping_name,
        //                 shipping_street,
        //                 shipping_city,
        //                 shipping_state,
        //                 shipping_zip
        //             };
        //         }
        //         return item;
        //     });
        //     // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
        //     this.clearFormInputs()
        //     this.setState({shippingAddresses})
        //     this.handleModalClose("upsertShippingAddressesModal")
        // } else {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error',
        //         text: 'An error occurred while updating the shipping address. Please try again.',
        //         confirmButtonText: 'OK',
        //     });
        //     console.error("Error updating shipping address:", responseBack.status.message);
        // }
    }

    updateShippingAddressList = (responseBack, newAddress = {}) => {
        const {
            id,
            customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;
        const isCreating = this.state.isCreatingShippingAddress;
        let shippingAddresses = {};

        if (responseBack.status.code === 1) {
            if(isCreating) {
                // Actualizar lista con nuevo item
                shippingAddresses = [
                    ...this.state.shippingAddresses,
                    newAddress
                ]
            } else{
                shippingAddresses = this.state.shippingAddresses.map(item => {
                        // Actualizar lista con los cambios de un item ya existente
                        if (item.id === id) {
                            return {
                                ...item,
                                customer_no,
                                shipping_name,
                                shipping_street,
                                shipping_city,
                                shipping_state,
                                shipping_zip
                            };
                        }
                        return item;
                });
            }
            // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
            this.clearFormInputs()
            this.setState({shippingAddresses})
            this.handleModalClose("upsertShippingAddressesModal")
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while updating the shipping address. Please try again.',
                confirmButtonText: 'OK',
            });
            console.error("Error updating shipping address:", responseBack.status.message);
        }
    }

    clearFormInputs = () => {
        this.setState({shippingAddressSelected: {id: '', customer_no: '', shipping_name: '', shipping_street: '', shipping_city: '', shipping_state: '', shipping_zip: ''}})
    }

    handleshippingAddressesModal = () => {
        this.getAllShippingAddress()
        this.setState({shippingAddressesModal: true})
    }

    handleAddShippingAddressesModal = () => {
        this.setState({upsertShippingAddressesModal: true, isCreatingShippingAddress: true})
    }
    
    handleUpdateShippingAddress = (item) => {
        this.setState({upsertShippingAddressesModal: true, shippingAddressSelected: {...item}})
    }
    
    handleModalClose = (modal) => {
        this.setState({[modal]: false})
    }


    render() {
        const { Customer, invoices, shippingAddressSelected } = this.state;

        return (
            <div>
                {/* Main menu */}
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Customer Management</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please select a customer or create a new one</p>
                </div>
                <div className='row pb-2 d-flex justify-content-center mx-3'>
                    <div className='col-sm-12'>
                        {
                        Customer?
                            <div className='row pt-2'>
                                <div className='col-sm-6 col-md-3 mb-3'>
                                    <div className="card mb-3">
                                        <div className='card-body'>
                                            <div className='text-end'>
                                                <a className="btn blueButton" href="/update-customer"><MdEdit /></a>
                                            </div>
                                            <div className='col-sm-12 InputText text-center'>
                                                <h3>{Customer.CustomerName}</h3>
                                                <p>{Customer.CustomerNo}</p>
                                            </div>
                                            <table className="table mb-0 table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <th><span className="fw-medium">Email</span></th>
                                                        <td>{Customer.EmailAddress}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Contact Name</span></th>
                                                        <td>{Customer.TelephoneNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Phone Number</span></th>
                                                        <td>{Customer.TelephoneNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Sales Person</span></th>
                                                        <td>{Customer.SalespersonNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Tax Schedule</span></th>
                                                        <td>{Customer.TaxSchedule}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Terms Code</span></th>
                                                        <td>{Customer.TermsCode}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Price Level</span></th>
                                                        <td>{Customer.PriceLevel}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='card mb-3'>
                                        <div className="card-body">
                                            <table className="table mb-0 table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <th><span className="fw-medium">Address Line</span></th>
                                                        <td>{Customer.AddressLine1}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Zip Code</span></th>
                                                        <td>{Customer.TelephoneNo}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">City</span></th>
                                                        <td>{Customer.City}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">State</span></th>
                                                        <td>{Customer.State}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Country</span></th>
                                                        <td>{Customer.CountryCode}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Route</span></th>
                                                        <td>{Customer.UDF_RUTA}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><span className="fw-medium">Credit Limit</span></th>
                                                        <td>{Customer.CreditLimit}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className='d-flex justify-content-center mt-4'>
                                                <button className='btn blueButton' onClick={() => this.handleshippingAddressesModal()}>Shipping addresses</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-6 col-md-9'>
                                    <div className="card mb-3">
                                        <div className='card-body'>
                                            <table className="table mb-0 table-borderless">
                                                <thead>
                                                    <tr>
                                                        <th className='text-center'>Invoice No</th>
                                                        <th className='text-center'>Date</th>
                                                        <th className='text-center'>Sales Person</th>
                                                        <th className='text-center'>Sales Order</th>
                                                        <th className='text-center'>Total</th>
                                                        <th className='text-center'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        invoices?
                                                            invoices.map((invoice, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td className='text-center'>{invoice.InvoiceNo}</td>
                                                                        <td className='text-center'>{DateFormatMAS90(invoice.InvoiceDate)}</td>
                                                                        <td className='text-center'>{invoice.SalespersonNo}</td>
                                                                        <td className='text-center'>{invoice.SalesOrderNo ? invoice.SalesOrderNo : "N/A" }</td>
                                                                        <td className='text-center'>${NumberFormat(pricesFormat(invoice.NonTaxableSalesAmt))}</td>
                                                                        <td className='text-center'> <button onClick={ () => this.loadInvoice(invoice)}>show invoice</button>
                                                                            {
                                                                                this.state.invoiceSelected === invoice.InvoiceNo &&  this.state.loadInvoice &&
                                                                                (
                                                                                    MobileDisp() ?
                                                                                        (
                                                                                            <InvoicePDF
                                                                                                id={'InvoiceWPrint'}
                                                                                                colorButton='orangeButton'
                                                                                                titleButton='Invoice Print'
                                                                                                title='Invoice Print'
                                                                                                CompanyTitle='Mayaland'
                                                                                                InvoiceType="Invoice"
                                                                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                                                                                InvoiceHeader={['Invoice Number:', invoice.InvoiceNo, 'Date:', DateFormatMAS90(invoice.InvoiceDate), 'Grocer:', invoice.SalespersonNo, 'Client No:', invoice.CustomerNo]}
                                                                                                Box1={[invoice.BillToName, invoice.BillToAddress1, invoice.BillToCity + ", " + invoice.BillToState + " " + invoice.BillToZipCode]}
                                                                                                Box2={[invoice.BillToName, invoice.BillToAddress1, invoice.BillToCity + ", " + invoice.BillToState + " " + invoice.BillToZipCode]}
                                                                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(invoice.TermsCode)]}
                                                                                                DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                                                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "Price", "", "Total"]}
                                                                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                                                                Detail={ this.state.invoiceProducts}
                                                                                                breakpoint={55}
                                                                                                quantSignDolar={this.realLongDetail()}
                                                                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                                                                bottomInformation={[
                                                                                                    NumberFormat(this.state.loadInvoice.totalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.loadInvoice.totalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.loadInvoice.NonTaxableAmt)),
                                                                                                    "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.loadInvoice.FreightAmt)),
                                                                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.loadInvoice.FreightAmt) + Number(this.state.loadInvoice.NonTaxableAmt)))
                                                                                                ]}
                                                                                                bottomStyle={[
                                                                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                ]}
                                                                                                bottomMessage={"Comment:" + invoice.Comment + "\nNo Returns after 1 day, No se aceptan devoluciones despues de 1 dia.\nAll returned checks will be subject to a $30 precessing fee. Todo cheque devuelto tendra un cargo de $30."}
                                                
                                                                                            />
                                                                                        )
                                                                                        :
                                                                                        (
                                                                                            <DownloadInvoicePDF
                                                                                                id={'InvoiceWPrint'}
                                                                                                colorButton='orangeButton'
                                                                                                titleButton='Invoice Print'
                                                                                                title='Invoice Print'
                                                                                                CompanyTitle='Mayaland'
                                                                                                InvoiceType="Invoice"
                                                                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                                                                                InvoiceHeader={['Invoice Number:', invoice.InvoiceNo, 'Date:', DateFormatMAS90(invoice.InvoiceDate), 'Grocer:', invoice.SalespersonNo, 'Client No:', invoice.CustomerNo]}
                                                                                                Box1={[invoice.BillToName, invoice.BillToAddress1, invoice.BillToCity + ", " + invoice.BillToState + " " + invoice.BillToZipCode]}
                                                                                                Box2={[invoice.BillToName, invoice.BillToAddress1, invoice.BillToCity + ", " + invoice.BillToState + " " + invoice.BillToZipCode]}
                                                                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(invoice.TermsCode)]}
                                                                                                DescriptionKeys={["quantityShipped", "itemCode", "SKU", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                                                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "Price", "", "Total"]}
                                                                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                                                                Detail={this.state.invoiceProducts}
                                                                                                breakpoint={55}
                                                                                                quantSignDolar={this.realLongDetail()}
                                                                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                                                                bottomInformation={[
                                                                                                    NumberFormat(this.state.loadInvoice.totalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.loadInvoice.totalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.loadInvoice.NonTaxableAmt)),
                                                                                                    "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.loadInvoice.FreightAmt)),
                                                                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.loadInvoice.FreightAmt) + Number(this.state.loadInvoice.NonTaxableAmt)))
                                                                                                ]}
                                                                                                bottomStyle={[
                                                                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                                                                ]}
                                                                                                bottomMessage={"Comment:" + invoice.Comment + "\nNo Returns after 1 day, No se aceptan devoluciones despues de 1 dia.\nAll returned checks will be subject to a $30 precessing fee. Todo cheque devuelto tendra un cargo de $30."}
                                                                                                docname={invoice.InvoiceNo}
                                                                                            />
                                                                                        )
                                                                                )
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        : <></>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :<></>
                        }
                    </div>
                </div>
                <SmallModal centered={true} size="xl" title="Shipping address" show={this.state.shippingAddressesModal} close={(modal = "shippingAddressesModal") => this.handleModalClose(modal)}>
                    <div>
                        <div className="d-flex justify-content-end mb-3">
                            <button className='btn greenButton' onClick={() => this.handleAddShippingAddressesModal()}>New Address</button>
                        </div>
                        <table className='table table-hover'>
                                <thead>
                                    <tr className='table-blue-header text-center'>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Zip Code</th>
                                        <th>Actions</th>
                                    </tr>
                            </thead>
                            <tbody>
                                {this.state.shippingAddresses.map((item, i) => (
                                    <tr className='text-center' key={i}>
                                        <td className='textTableSize'>{item.shipping_name}</td>
                                        <td className='textTableSize'>{item.shipping_street}</td>
                                        <td className='textTableSize'>{item.shipping_city}</td>
                                        <td className='textTableSize'>{item.shipping_state}</td>
                                        <td className='textTableSize'>{item.shipping_zip}</td>
                                        <td className='textTableSize'><button className="btn blueButton" onClick={() => this.handleUpdateShippingAddress(item)}><MdEdit /></button></td>
                                    </tr>
                                ))}
                                </tbody>
                        </table>
                    </div>
                </SmallModal>
                <SmallModal centered={true} size="xl" title="Shipping address" show={this.state.upsertShippingAddressesModal} close={(modal = "upsertShippingAddressesModal") => this.handleModalClose(modal)}>
                    <div>
                        <form>
                            <input type="hidden" name="id" value={shippingAddressSelected.id} />
                            <div className="mb-3">
                                <label className="form-label">Customer No</label>
                                <input readOnly type="text" className="form-control" name="customerNo" value={Customer? Customer.CustomerNo : shippingAddressSelected.customer_no} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control" name="name" value={shippingAddressSelected.shipping_name} onChange={(e) => this.setState({shippingAddressSelected: {...shippingAddressSelected, shipping_name: e.target.value}})} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Shipping Street</label>
                                <input type="text" className="form-control" name="shipping_street" value={shippingAddressSelected.shipping_street} onChange={(e) => this.setState({shippingAddressSelected: {...shippingAddressSelected, shipping_street: e.target.value}})} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Shipping City</label>
                                <input type="text" className="form-control" name="shipping_city" value={shippingAddressSelected.shipping_city} onChange={(e) => this.setState({shippingAddressSelected: {...shippingAddressSelected, shipping_city: e.target.value}})} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Shipping State</label>
                                <input type="text" className="form-control" name="shipping_state" value={shippingAddressSelected.shipping_state} onChange={(e) => this.setState({shippingAddressSelected: {...shippingAddressSelected, shipping_state: e.target.value}})} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Shipping Zip</label>
                                <input type="text" className="form-control" name="shipping_zip" value={shippingAddressSelected.shipping_zip} onChange={(e) => this.setState({shippingAddressSelected: {...shippingAddressSelected, shipping_zip: e.target.value}})} />
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <button type="button" className="btn grayButton me-5" onClick={() => this.handleModalClose("upsertShippingAddressesModal")}>Cancel</button>
                                <button hidden={this.state.isCreatingShippingAddress} type="button" className="btn blueButton" onClick={() => this.upsertShippingAddress()}>Update</button>
                                <button hidden={!this.state.isCreatingShippingAddress} type="button" className="btn blueButton" onClick={() => this.addShippingAddresses()}>create</button>
                            </div>
                        </form>
                    </div>
                </SmallModal>
            </div>
        )
    }
}